const TAG_COLORS = [
  { bg: "#0033CC1a", fg: "#0033CC" },
  { bg: "#00C7811a", fg: "#00996b" },
  { bg: "#FFB8001a", fg: "#b37f00" },
  { bg: "#7C3AED1a", fg: "#7C3AED" },
  { bg: "#FF3B301a", fg: "#d92c22" },
  { bg: "#0891B21a", fg: "#0891B2" },
  { bg: "#DB27771a", fg: "#DB2777" },
];

export function tagColor(tag) {
  let h = 0;
  for (let i = 0; i < tag.length; i++) h = (h * 31 + tag.charCodeAt(i)) >>> 0;
  return TAG_COLORS[h % TAG_COLORS.length];
}
